import { apiFetch } from "./client";

/** The full-time plan: saved inputs plus the real numbers they're measured against. */
export function getPlan() {
  return apiFetch("/api/admin/plan");
}

/** Save part of the plan's inputs (overhead is sent whole; checks merge). */
export function savePlan(change) {
  return apiFetch("/api/admin/plan", { method: "PUT", body: change });
}
